app.controller('studentMessagesCtrl', [
    '$scope', '$interval', '$state', '$stateParams', 'messageService', function ($scope, $interval, $state, $stateParams, messageService) {
    	var vm = this;

		vm.messageService = messageService;
    	vm.messageService.setLastRead();

		vm.messages = angular.copy(vm.messageService.messages);
	
    	$scope.$on('messageServiceUpdated', function() {
			console.log("tudentMessagesCtrl: sync'd messages with messageService");
			vm.messages = angular.copy(vm.messageService.messages);
    	});

	}
]);
